var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9203 27.3334C23.4075 27.3334 20.8831 26.7492 18.3472 25.5808C15.8113 24.4124 13.4814 22.7641 11.3575 20.6359C9.2336 18.5077 7.58745 16.1778 6.41907 13.6462C5.25069 11.1146 4.6665 8.59238 4.6665 6.07958C4.6665 5.67592 4.79984 5.33953 5.0665 5.07042C5.33317 4.80131 5.6665 4.66675 6.0665 4.66675H10.4152C10.7519 4.66675 11.0489 4.77658 11.3062 4.99625C11.5635 5.21592 11.7271 5.48728 11.7972 5.81035L12.5613 9.73338C12.6143 10.0975 12.6032 10.4103 12.528 10.6718C12.4528 10.9334 12.3177 11.153 12.1228 11.3308L9.04337 14.3283C9.5391 15.2359 10.1053 16.0945 10.7421 16.9039C11.3789 17.7133 12.0682 18.4864 12.81 19.2232C13.5417 19.9548 14.3195 20.6343 15.1434 21.2616C15.9673 21.889 16.8571 22.4727 17.8126 23.0129L20.8049 19.9949C21.0135 19.7779 21.2661 19.6257 21.5626 19.5386C21.8592 19.4514 22.1673 19.43 22.487 19.4745L26.1895 20.2283C26.5263 20.3172 26.8011 20.489 27.0139 20.7437C27.2267 20.9984 27.3331 21.2873 27.3331 21.6104V25.9334C27.3331 26.3334 27.1985 26.6667 26.9294 26.9334C26.6603 27.2 26.3239 27.3334 25.9203 27.3334ZM8.09724 12.436L10.4767 10.159C10.5195 10.1249 10.5472 10.0778 10.5601 10.018C10.5729 9.95817 10.5708 9.90262 10.5537 9.85135L9.97417 6.87185C9.95708 6.80347 9.92717 6.75219 9.88444 6.71802C9.8417 6.68382 9.78615 6.66672 9.71777 6.66672H6.86647C6.8152 6.66672 6.77247 6.68382 6.73827 6.71802C6.70407 6.75219 6.68697 6.79493 6.68697 6.84622C6.75535 7.75733 6.90449 8.68297 7.1344 9.62315C7.36434 10.5633 7.68528 11.5009 8.09724 12.436ZM19.6972 23.959C20.581 24.371 21.5028 24.686 22.4626 24.9039C23.4224 25.1219 24.3195 25.2513 25.1536 25.2924C25.2049 25.2924 25.2477 25.2753 25.2818 25.2411C25.316 25.2069 25.3331 25.1641 25.3331 25.1129V22.3078C25.3331 22.2394 25.316 22.1838 25.2818 22.1411C25.2477 22.0983 25.1964 22.0684 25.128 22.0513L22.328 21.4821C22.2767 21.465 22.2319 21.4629 22.1934 21.4757C22.1549 21.4885 22.1143 21.5163 22.0716 21.559L19.6972 23.959Z",
    fill: "#F7F7F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.930056b5e8b2bf0b2f9ee11863e5450e.svg";
export { ForwardRef as ReactComponent };